/* ============================================================================
   EH STACK PACK UPSELL — product page 2BUY1FREE pitch
   ----------------------------------------------------------------------------
   STACK PACK の商品ページでのみ、カートに入れるボタン直下へ 2BUY1FREE の
   積み上げ算ブロックを挿入する。期間: 2026-09-18 00:00 〜 2026-09-27 23:59 (JST)。
   （2026-09-17 日程を確定版へ更新：旧 9/4〜9/30 → 9/18〜9/27。値上げ告知の文言はオーナー指示で撤去）
   期間外の確認は ?ehpreview=1。加算のみ / 自己完結 / 非破壊。
   ============================================================================ */
(function () {
  'use strict';
  if (window.__ehStackPackUpsell) return;
  window.__ehStackPackUpsell = true;
  if (!document.body || !/(^|\s)template-product(\s|$)/.test(document.body.className)) return;

  var path = '';
  try { path = decodeURIComponent(location.pathname); } catch (e) { path = location.pathname; }
  if (path.indexOf('stack-pack') === -1) return;

  var START = new Date('2026-09-18T00:00:00+09:00').getTime();
  var END   = new Date('2026-09-27T23:59:59+09:00').getTime();
  var PREVIEW = /[?&]ehpreview=1/.test(location.search) ||
    /* 未公開テーマのプレビュー（Shopifyアプリ・管理画面の「プレビュー」）では日付に関係なく表示する。
       公開テーマ（role=main）になったら期間ゲートどおり。2026-09-17：スマホのプレビューで見えなかったため追加 */
    !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');
  var now = Date.now();
  if (!PREVIEW && (now < START || now > END)) return;

  var CSS = [
    '#eh-sp-upsell{--e1:#385C60;--gd:#e9c987;margin:20px 0;font-family:inherit;}',
    '.ehspu-card{position:relative;overflow:hidden;border-radius:18px;padding:clamp(20px,4vw,30px) clamp(18px,4vw,30px);color:#fff;isolation:isolate;background:radial-gradient(90% 120% at 92% 4%,rgba(233,201,135,.26),transparent 58%),linear-gradient(135deg,#22403f 0%,#385C60 52%,#4a848a 100%);box-shadow:0 18px 40px -22px rgba(22,41,43,.7),inset 0 0 0 1px rgba(233,201,135,.16);}',
    '.ehspu-eyebrow{font-size:11px;letter-spacing:.22em;font-weight:800;text-transform:uppercase;color:var(--gd);margin:0 0 8px;}',
    '.ehspu-title{margin:0;font-size:clamp(20px,3.4vw,28px);font-weight:900;letter-spacing:.02em;line-height:1.28;color:#fff;}',
    '.ehspu-title b{background:linear-gradient(180deg,#fff,#fdf3d6 42%,#e9c987 80%,#d9b264);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;color:transparent;}',
    '.ehspu-sub{margin:10px 0 0;font-size:clamp(12.5px,1.7vw,14px);line-height:1.8;color:rgba(232,242,242,.9);font-weight:500;}',
    '.ehspu-sub b{color:#fff;font-weight:800;}',
    '.ehspu-combos{margin:clamp(16px,3vw,22px) 0 0;display:flex;flex-direction:column;gap:9px;}',
    '.ehspu-combo{display:flex;align-items:center;gap:10px;padding:12px 14px;border-radius:13px;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.1);}',
    '.ehspu-combo--best{background:linear-gradient(180deg,rgba(233,201,135,.18),rgba(200,164,92,.07));border-color:rgba(233,201,135,.42);}',
    '.ehspu-mix{flex:1 1 auto;min-width:0;font-size:clamp(12.5px,1.7vw,14.5px);font-weight:700;line-height:1.45;color:#fff;}',
    '.ehspu-mix b{color:var(--gd);font-weight:900;margin:0 .1em;}',
    '.ehspu-arrow{flex:0 0 auto;color:rgba(233,201,135,.65);font-size:15px;}',
    '.ehspu-pay{flex:0 0 auto;text-align:right;line-height:1.15;}',
    '.ehspu-price{display:block;font-size:clamp(17px,2.6vw,22px);font-weight:900;color:#fff;letter-spacing:.01em;}',
    '.ehspu-note{display:block;margin-top:2px;font-size:10.5px;font-weight:700;color:var(--gd);white-space:nowrap;}',
    '.ehspu-punch{margin:clamp(16px,3vw,20px) 0 0;font-size:clamp(13px,1.9vw,15px);font-weight:800;letter-spacing:.01em;color:#fff;text-align:center;line-height:1.6;}',
    '.ehspu-punch b{color:var(--gd);}',
    '@media(max-width:480px){.ehspu-combo{gap:7px;padding:11px 12px;}.ehspu-arrow{display:none;}}'
  ].join('\n');

  function build() {
    var sec = document.createElement('section');
    sec.id = 'eh-sp-upsell';
    sec.setAttribute('aria-label', '2BUY1FREE 組み合わせ提案');
    sec.innerHTML =
      '<div class="ehspu-card">' +
        '<p class="ehspu-eyebrow">MORE IS MORE ・ 2BUY1FREE</p>' +
        '<h2 class="ehspu-title">1箱で、終わらせないで。<br><b>2箱分の値段で、3箱。</b></h2>' +
        '<p class="ehspu-sub">このセールは<b>「カートに3点で、1番安い1点が¥0」</b>。STACK PACKを3箱そろえると<b>ネックレス15本</b>になります。友人と5本ずつ分けても、全部自分で重ねても自由です。</p>' +
        '<div class="ehspu-combos">' +
          '<div class="ehspu-combo">' +
            '<span class="ehspu-mix">STACK PACK <b>×1箱</b>（ネックレス5本）</span>' +
            '<span class="ehspu-arrow" aria-hidden="true">&#8594;</span>' +
            '<span class="ehspu-pay"><span class="ehspu-price">¥10,000</span><span class="ehspu-note">1本あたり¥2,000</span></span>' +
          '</div>' +
          '<div class="ehspu-combo">' +
            '<span class="ehspu-mix">STACK PACK <b>×2箱</b>（ネックレス10本）</span>' +
            '<span class="ehspu-arrow" aria-hidden="true">&#8594;</span>' +
            '<span class="ehspu-pay"><span class="ehspu-price">¥20,000</span><span class="ehspu-note">1本あたり¥2,000</span></span>' +
          '</div>' +
          '<div class="ehspu-combo ehspu-combo--best">' +
            '<span class="ehspu-mix">STACK PACK <b>×3箱</b>（ネックレス15本）</span>' +
            '<span class="ehspu-arrow" aria-hidden="true">&#8594;</span>' +
            '<span class="ehspu-pay"><span class="ehspu-price">¥20,000</span><span class="ehspu-note">1箱が¥0・1本あたり¥1,333</span></span>' +
          '</div>' +
        '</div>' +
        '<p class="ehspu-punch">同じ¥20,000でも、<b>2箱ではなく3箱</b>。<br>この価格は9月27日(日)までです。</p>' +
      '</div>';
    return sec;
  }

  function place(node) {
    if (document.getElementById('eh-sp-upsell')) return true;
    var atc = document.querySelector('.product-single__add-to-cart');
    if (atc && atc.parentNode) { atc.insertAdjacentElement('afterend', node); return true; }
    var form = document.querySelector('form.js-addtocart-form, .product-single__form');
    if (form && form.parentNode) { form.insertAdjacentElement('afterend', node); return true; }
    var info = document.querySelector('.product-single__metas, .bwp-single-info');
    if (info) { info.appendChild(node); return true; }
    return false;
  }

  function run() {
    if (document.getElementById('eh-sp-upsell')) return;
    var style = document.createElement('style');
    style.id = 'eh-sp-upsell-css';
    style.textContent = CSS;
    (document.head || document.documentElement).appendChild(style);
    var node = build();
    if (place(node)) return;
    var tries = 0;
    var iv = setInterval(function () { tries++; if (place(node) || tries > 30) clearInterval(iv); }, 150);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
})();
